<template>
  <div v-if="customer" class="relative bg-white rounded-2xl shadow-md p-6 mx-auto">
    <h3 class="text-lg sm:text-xl font-semibold text-gray-800 mb-4">
      {{ customer.firstName }} {{ customer.lastName }}
    </h3>

    <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-x-8 gap-y-2">
      <div class="space-y-2">
        <StackedField :label="t('email')" :value="customer.email" />
        <StackedField :label="t('phone')" :value="customer.phone" />
      </div>
      <div class="space-y-2">
        <StackedField :label="t('birth_date')" :value="customer.birthDate" />
        <StackedField :label="t('birth_place')" :value="birthPlace" />
      </div>
      <div class="space-y-2">
        <StackedField :label="t('address')" :value="customer.fullAddress" />
      </div>
    </div>
  </div>
</template>

<script>
import { StackedField } from "@estaly/ui";
import { useI18n } from "vue-i18n";

export default {
  name: "CustomerInformations",

  components: { StackedField },

  props: {
    customer: {
      type: Object,
      default: null,
    },
  },

  setup() {
    const { t } = useI18n();
    return { t };
  },

  computed: {
    birthPlace() {
      return [this.customer.birthCity, this.customer.birthCountry].filter(Boolean).join(", ");
    },
  },
};
</script>

<i18n src="./CustomerInformations.i18n.json"></i18n>
